import { Link, Outlet } from "react-router-dom";
import Footer from "../Footer";

export default function EventLayout2() {
  return (
    <>
      <nav
        style={{ backgroundColor: "#E62B1E" }}
        className="navbar navbar-expand-lg"
      >
        <div className="container">

          {/* TEDxSetapak Logo */}
          <Link
            className="navbar-brand d-flex flex-column"
            to="/event2/theme"
          >
            <div className="d-flex align-items-center">
              <span
                style={{
                  fontWeight: 800,
                  color: "white",
                  fontSize: "1.8rem",
                }}
              >
                TED
              </span>

              <span
                style={{
                  fontWeight: 700,
                  color: "white",
                  fontSize: "1.5rem",
                  marginLeft: "2px",
                  position: "relative",
                  top: "-0.3rem",
                }}
              >
                x
              </span>

              <span
                style={{
                  fontWeight: 600,
                  color: "white",
                  fontSize: "1.5rem",
                  marginLeft: "2px",
                }}
              >
                Setapak
              </span>
            </div>

            <small
              className="text-white"
              style={{
                fontSize: "1rem",
                fontWeight: 600,
              }}
            >
              31 Oct 2026 · TAR UMT
            </small>
          </Link>

          {/* Mobile Toggle */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarEvent2"
            aria-controls="navbarEvent2"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Navigation */}
          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarEvent2"
          >
            <ul className="navbar-nav">

              <li className="nav-item">
                <Link
                  className="nav-link text-white"
                  to="/event2/theme"
                >
                  Theme
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className="nav-link text-white"
                  to="/event2/speakers"
                >
                  Speakers
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className="nav-link text-white"
                  to="/event2/schedule"
                >
                  Schedule
                </Link>
              </li>

              {/* Organising Team */}
              <li className="nav-item">
                <Link
                  className="nav-link text-white"
                  to="/event2/team"
                >
                  Team
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className="nav-link text-white"
                  to="/event2/location"
                >
                  Location
                </Link>
              </li>

            </ul>
          </div>
        </div>
      </nav>

      {/* Page Content */}
      <main className="container py-4">
        <Outlet />
      </main>

      <Footer />
    </>
  );
}